export default __webpack_public_path__ + "static/media/loss.7f85e456.png";